// Centralised image assets (from design_guidelines)
export const IMG = {
  hero: "https://images.unsplash.com/photo-1728910156510-77488f19b152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwaW5kaWFuJTIwZm9vZCUyMHBsYXRpbmd8ZW58MHx8fHwxNzgwMjY0MDg2fDA&ixlib=rb-4.1.0&q=85",
  emeraldBg: "https://static.prod-images.emergentagent.com/jobs/f14e3401-979d-4da2-975f-34f3820bec60/images/3c427e1908931201cfd57fe97a514d279a2670becf0e6d23e849b78120bf562a.png",
  elephant: "https://static.prod-images.emergentagent.com/jobs/f14e3401-979d-4da2-975f-34f3820bec60/images/3bb0f77ecb299406814a53dd85f894b2d49b08e43ce9056d85eabedbcb41b4bc.png",
  food1: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwaW5kaWFuJTIwZm9vZCUyMHBsYXRpbmd8ZW58MHx8fHwxNzgwMjY0MDg2fDA&ixlib=rb-4.1.0&q=85",
  food2: "https://images.unsplash.com/photo-1589778655375-3e622a9fc91c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxwcmVtaXVtJTIwaW5kaWFuJTIwZm9vZCUyMHBsYXRpbmd8ZW58MHx8fHwxNzgwMjY0MDg2fDA&ixlib=rb-4.1.0&q=85",
  interior1: "https://images.pexels.com/photos/31175427/pexels-photo-31175427.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  interior2: "https://images.unsplash.com/photo-1709548145082-04d0cde481d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxjaGljJTIwcmVzdGF1cmFudCUyMGludGVyaW9yJTIwd2FybSUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4MDI2NDA4Nnww&ixlib=rb-4.1.0&q=85",
};

export const RESTAURANT = {
  name: "Infuse",
  fullName: "Infuse Modern Indian Restaurant",
  address: "4–5 Waddington Road, St Albans, Hertfordshire, AL3 5EX",
  phone: "01727 899446",
  phoneHref: "tel:+441727899446",
  email: "eat@infuseuk.com",
  bookUrl: "https://www.opentable.co.uk/booking/restref/availability?lang=en-GB&correlationId=06a515b2-f2fa-42d1-96fd-f444aadd2d76&restRef=188829&otSource=Restaurant%20website",
  orderUrl: "https://order.toasttab.com/online/infuse-modern-indian-bistro-4-5-waddington-road",
  giftCardUrl: "https://order.toasttab.com/egiftcards/infuse-modern-indian-bistro-4-5-waddington-road",
  mapsEmbed: "https://www.google.com/maps?q=4-5+Waddington+Road,+St+Albans,+AL3+5EX&output=embed",
  mapsLink: "https://www.google.com/maps/search/?api=1&query=Infuse+Modern+Indian+Restaurant+St+Albans",
  hours: [
    { day: "Monday", time: "Closed" },
    { day: "Tuesday", time: "12–3 & 5–10" },
    { day: "Wednesday", time: "12–3 & 5–10" },
    { day: "Thursday", time: "12–3 & 5–10" },
    { day: "Friday", time: "12–3 & 5–10" },
    { day: "Saturday", time: "12–3 & 5–10" },
    { day: "Sunday", time: "12–9" },
  ],
};
